<script lang="ts">
import { computed, defineComponent, h, unref } from 'vue';

import { classNames, hSlot } from '@components/utils';

import type { PropType } from 'vue';

export const componentName = 'CdsToolbarTitle';
export default defineComponent({
  name: componentName,
  props: {
    shrink: {
      type: Boolean as PropType<boolean>,
      default: false
    }
  },
  setup(props, { slots }) {
    const classes = computed(() => classNames('cds-toolbar__title', { 'cds-toolbar__title--shrink': props.shrink }));

    return () => h('div', { class: unref(classes) }, hSlot(slots.default));
  }
});
</script>
